import { CarModelFinishingLevel } from "api"
import Image from "next/image"
import InformationPopUp from "reusable/popups/InformationPopUp"
import styled from "styled-components"
import { TypographyRtl } from "theme/shared"
import BulletsList from "./BulletsList"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const StyledImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
type PopupProps = {
  onClose: () => void
  open: boolean
  modelName: string
  data: CarModelFinishingLevel
}

const FinishingLevelsPopup = ({
  open,
  onClose,
  modelName,
  data,
}: PopupProps) => {
  return (
    <InformationPopUp
      open={open}
      onClose={onClose}
      title={`${modelName}`}
      subtitle="מפרט מלא"
    >
      <StyledWrapper>
        {data?.image?.imageUrl && (
          <StyledImageWrapper>
            <Image
              src={data?.image?.imageUrl}
              alt={data?.image?.alt}
              width={320}
              height={180}
              lazyBoundary="800px"
            />
          </StyledImageWrapper>
        )}

        <TypographyRtl variant="h2">{data.name}</TypographyRtl>
        {data.categories.map((category, index) => (
          <div key={`category-${index}`}>
            <TypographyRtl variant="body1" $mb="10px">
              {category.name}
            </TypographyRtl>
            <BulletsList
              textList={category.items.map(
                (item) => `${item.name} ${item.description}`
              )}
            />
          </div>
        ))}
      </StyledWrapper>
    </InformationPopUp>
  )
}

export default FinishingLevelsPopup
